import { fetchNaniexpert } from "@/apis/naniexpert/base";
import type { GetAICBQGenerationAllResponse } from "@/types/apis/naniexpert";

const AICBQ_GENERATION_ALL_URL =
  "/cache/googlesheet/ai_competency_based_questiongeneration/all";

export const fetchAICBQGenerationAll =
  (): Promise<GetAICBQGenerationAllResponse> =>
    fetchNaniexpert<GetAICBQGenerationAllResponse>({
      url: AICBQ_GENERATION_ALL_URL,
      method: "GET",
    });
